import React, { useEffect, useState } from 'react';
import { API_URL } from 'shared/config/env';

type SampleMessageProps = {
  api_path: string;
};

const MessageContent = ({ message }: { message: string }) => (
  <div className="flex items-center justify-center min-h-screen bg-gray-50">
    <h1 className="text-2xl font-bold text-gray-800">
      {message || 'Loading...'}
    </h1>
  </div>
);

const SampleMessage: React.FC<SampleMessageProps> = ({ api_path }) => {
  const [message, setMessage] = useState<string>('');

  useEffect(() => {
    fetch(`${API_URL}/${api_path}`)
      .then((res) => res.json())
      .then((data) => setMessage(data.message))
      .catch(() => setMessage('Error fetching message'));
  }, [api_path]);

  return <MessageContent message={message} />;
};

export default SampleMessage;
